import {gql} from "apollo-angular";
import {baseResponse} from "src/app/store/base.graphql";
import {institutionFields} from "../../system-settings/institution/institution.graphql";

const serviceCollaborationFields = `
      id
      uniqueId
      collaborationSetting {
        id
        uniqueId
        reason
        createdAt
        createdBy {
          id
          profileUniqueId
          userFirstName
          userLastName
          userEmail
          profilePhone
          profileTitle
          profilePhoto
          profileIsActive
          profileIsDeactivated
          profileType
        }
      }
      system{
      id
        systemUniqueId
        systemShortform
        systemName
        systemInstitution{
        ${institutionFields}
        }
        }
      hasIntegration
      collaborationMean
      systemIntegration
      collaboratedInstitution {
        id
        institutionUniqueId
        institutionName
        institutionShortform
      }
      createdDate
`;

export const CREATE_SERVICE_COLLABORATION = gql`
mutation CreateServiceCollaborationMutation($input: ServiceCollaborationInputObject) {
  createServiceCollaborationMutation(input: $input) {
    response {
      ${baseResponse}
    }
    data {
      ${serviceCollaborationFields}
    }
  }
}
`;

export const UPDATE_SERVICE_COLLABORATION = gql`
mutation UpdateServiceCollaborationMutation($input: ServiceCollaborationInputObject) {
  updateServiceCollaborationMutation(input: $input) {
    response {
      ${baseResponse}
    }
    data {
      ${serviceCollaborationFields}
    }
  }
}
`;

export const GET_ALL_SERVICE_COLLABORATIONS = gql`
  query GetInstitutionServicesCollaborations($serviceUniqueId: String) {
    getInstitutionServicesCollaborations(serviceUniqueId: $serviceUniqueId) {
    response{
        ${baseResponse}
    }
    data{
        ${serviceCollaborationFields}
    }
  }
}
`;


export const DELETE_COLLABORATION_REASON = gql`
mutation DeleteServiceCollaborationMutation($uniqueId: String!) {
  deleteServiceCollaborationMutation(uniqueId: $uniqueId) {
    response {
      ${baseResponse}
    }
  }
}
`
